import { type DomainAccessControlConfig } from 'domains/store-hours-bulk/utils/domain/accessControl'

// No special access is needed for viewing Store Hours
export const storeHoursBulkAccessControl: DomainAccessControlConfig = {}
